import { RDDarkService } from './../dark.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'rd-loader',
  template: `<div class="loaderContainer {{color}}Loader {{animation}}Animation" [class.rdDark]="dark">
  <ng-container *ngIf="type === 'circle'; else dot">
    <div class="circleLoader" [style.width.px]="size*(1-borderPercentage/100)" [style.height.px]="size*(1-borderPercentage/100)"
    [style.borderSize.px]="size*(borderPercentage/100)"></div>
  </ng-container>
  <ng-template #dot>
    <div class="dotLoader" [style.width.px]="size" [style.height.px]="size"></div>
  </ng-template>
</div>
`,
  styles: [`.loaderContainer{--main-color:#ba9e5a}.loaderContainer .circleLoader{border:10px solid transparent;border-top-color:var(--main-color);border-radius:50%;-webkit-animation:1s linear infinite spin;animation:1s linear infinite spin}.loaderContainer .dotLoader{background-color:var(--main-color);border-radius:50%;-webkit-animation:1s linear infinite grow;animation:1s linear infinite grow}.loaderContainer.linearAnimation>div{-webkit-animation-timing-function:linear;animation-timing-function:linear}.loaderContainer.hilltopAnimation>div{-webkit-animation-timing-function:cubic-bezier(.3,.1,.3,.85);animation-timing-function:cubic-bezier(.3,.1,.3,.85)}.loaderContainer.greenLoader{--main-color:#72ba5a}.loaderContainer.blueLoader{--main-color:#5a5aba}.loaderContainer.blue-lightLoader{--main-color:#5aa2ba}.loaderContainer.redLoader{--main-color:#ba5a5a}.loaderContainer.purpleLoader{--main-color:#a25aba}.loaderContainer.orangeLoader{--main-color:#ba8a5a}@-webkit-keyframes spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes grow{0%{-webkit-transform:scale(0);transform:scale(0);opacity:0}50%{opacity:1}100%{-webkit-transform:scale(1);transform:scale(1);opacity:0}}@keyframes grow{0%{-webkit-transform:scale(0);transform:scale(0);opacity:0}50%{opacity:1}100%{-webkit-transform:scale(1);transform:scale(1);opacity:0}}`]
})
export class RDLoaderComponent implements OnInit {

  @Input() size = 120;
  @Input() borderPercentage = 10;
  @Input() type = 'circle';
  @Input() color = 'gold';
  @Input() animation = 'linear';

  public dark = false;

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(res => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

}
